import React from 'react'
import { useApp } from '../../../context/AppProvider'
import { icon } from '../../../services/icon'

const InputRadio = ({ value, choice, title, onChange, helpBlock }) => {
    const { constructAffectTrueValue, constructName, checked, setHelpModal } = useApp()

    return (
        <div className="what-is-your-situation-choice">
            <input
                checked={checked?.includes(constructAffectTrueValue(value))}
                onChange={onChange}
                type="radio"
                name={constructName(title)}
                id={choice.id}
                value={JSON.stringify(choice)}
            />
            <div className="baseocom-content-label">
                <label htmlFor={choice.id}>{choice.label}</label>
                {helpBlock && (
                    <button
                        onClick={() => setHelpModal(helpBlock)}
                        type="button"
                        className="baseocom-btn-help-modal"
                    >
                        {icon('help')}
                    </button>
                )}
            </div>
        </div>
    )
}

export default InputRadio
